// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"b950feea","213":"90bdaeac","355":"0b6f688d","382":"8f61e525","404":"de9f1b8f","421":"29291fc5","621":"b3c76e87","745":"a26114e0","833":"db0b628c"}[chunkId] + ".chunk.js";
};